// This file is overwritten by compile_executables.ts for each target.
// In dev/npm mode it returns an empty string - RgBinaryProvider falls back to system rg.
export default '';
